<script lang="ts">
    import { Button, Icon } from "sveltestrap";
    import type { Section } from "../Model/Section";
    import { questionsFactory } from "../services";

    export let section: Section;
    export let prepend = false;

    let questionType: string = 'bool';

    function onAdd(): void {
        const question = questionsFactory.createNewQuestion(section.form, section, questionType);
        if (prepend) {
            section.prependQuestion(question);
        } else {
            section.addQuestion(question);
        }
    }
    
</script>

<style lang="scss">

    :global(.add-btn) {
        white-space: nowrap;
        border-top-left-radius: 0 !important;
        border-bottom-left-radius: 0 !important;
    }

</style>

<div class="d-flex">
    <select style="margin-right: -5px;" class="form-select form-select-sm" bind:value={questionType}>
        <option value="bool">Respuesta Simple</option>
        <option value="multiple">Respuesta Múltiple</option>
        <option value="text">Texto</option>
        <option value="date">Fecha</option>
        <option value="grid">Rejilla</option>
    </select>
    
    <Button class="add-btn" type="button" size="sm" on:click={onAdd}>
        <Icon name="plus" /> Añadir pregunta
    </Button>
    
</div>
